(function () {
  'use strict';

  var theme = window.theme || { routes: {}, strings: {} };

  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    var fmt = format || theme.moneyFormat || '${{amount}}';
    var match = fmt.match(/\{\{\s*(\w+)\s*\}\}/);
    function delimit(n, precision, thousands, decimal) {
      if (isNaN(n) || n == null) return '0';
      var num = (n / 100).toFixed(precision).split('.');
      var whole = num[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      return whole + (num[1] ? decimal + num[1] : '');
    }
    var value = '';
    switch (match ? match[1] : 'amount') {
      case 'amount_no_decimals': value = delimit(cents, 0, ',', '.'); break;
      case 'amount_with_comma_separator': value = delimit(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = delimit(cents, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator': value = delimit(cents, 2, "'", '.'); break;
      case 'amount_with_space_separator': value = delimit(cents, 2, ' ', ','); break;
      default: value = delimit(cents, 2, ',', '.');
    }
    return fmt.replace(/\{\{\s*\w+\s*\}\}/, value);
  }

  function announce(text) {
    var region = document.getElementById('live-region');
    if (!region) return;
    region.textContent = '';
    setTimeout(function () { region.textContent = text; }, 50);
  }

  /* Light / dark */
  function syncModeButtons() {
    var dark = document.documentElement.getAttribute('data-theme') === 'dark';
    document.querySelectorAll('[data-mode-toggle]').forEach(function (btn) {
      btn.setAttribute('aria-label', dark ? theme.strings.toLight : theme.strings.toDark);
      btn.setAttribute('aria-pressed', dark ? 'true' : 'false');
    });
  }
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-mode-toggle]');
    if (!btn) return;
    var next = document.documentElement.getAttribute('data-theme') === 'dark' ? 'light' : 'dark';
    document.documentElement.setAttribute('data-theme', next);
    try { localStorage.setItem('evr-mode', next); } catch (err) {}
    syncModeButtons();
  });

  /* Dialogs */
  function openDialog(dialog, opener) {
    if (!dialog || dialog.open) return;
    dialog._opener = opener || document.activeElement;
    dialog.showModal();
    document.documentElement.style.overflow = 'hidden';
    var focusTarget = dialog.querySelector('input[type="search"], [autofocus]');
    if (focusTarget) setTimeout(function () { focusTarget.focus(); }, 30);
  }
  function closeDialog(dialog) {
    if (!dialog || !dialog.open) return;
    dialog.close();
  }
  document.addEventListener('close', function (e) {
    if (e.target.tagName !== 'DIALOG') return;
    if (!document.querySelector('dialog[open]')) document.documentElement.style.overflow = '';
    if (e.target._opener && e.target._opener.focus) e.target._opener.focus();
  }, true);
  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-open-dialog]');
    if (opener) {
      e.preventDefault();
      openDialog(document.getElementById(opener.dataset.openDialog), opener);
      return;
    }
    var closer = e.target.closest('[data-close-dialog]');
    if (closer) {
      closeDialog(closer.closest('dialog'));
      return;
    }
    if (e.target.tagName === 'DIALOG') {
      var r = e.target.getBoundingClientRect();
      var inside = e.clientX >= r.left && e.clientX <= r.right && e.clientY >= r.top && e.clientY <= r.bottom;
      if (!inside) closeDialog(e.target);
    }
  });

  /* Close desktop dropdowns on outside click / Escape */
  document.addEventListener('click', function (e) {
    document.querySelectorAll('.header__dropdown[open]').forEach(function (d) {
      if (!d.contains(e.target)) d.removeAttribute('open');
    });
  });
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    document.querySelectorAll('.header__dropdown[open]').forEach(function (d) {
      d.removeAttribute('open');
      var s = d.querySelector('summary');
      if (s) s.focus();
    });
  });

  /* Auto-submit selects */
  document.addEventListener('change', function (e) {
    if (e.target.matches('[data-autosubmit]')) {
      var form = e.target.form;
      if (form) form.requestSubmit ? form.requestSubmit() : form.submit();
    }
  });

  /* Announcement bar */
  class AnnouncementBar extends HTMLElement {
    connectedCallback() {
      var items = this.querySelectorAll('.announcement__item');
      if (items.length < 2 || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      var i = 0;
      var interval = parseInt(this.dataset.interval, 10) || 6000;
      this._timer = setInterval(function () {
        items[i].classList.remove('is-active');
        i = (i + 1) % items.length;
        items[i].classList.add('is-active');
      }, interval);
    }
    disconnectedCallback() { clearInterval(this._timer); }
  }
  customElements.define('announcement-bar', AnnouncementBar);

  /* Header (placeholder element for future behavior) */
  class HeaderBar extends HTMLElement {
    connectedCallback() { syncModeButtons(); }
  }
  customElements.define('header-bar', HeaderBar);

  /* Predictive search */
  class PredictiveSearch extends HTMLElement {
    connectedCallback() {
      this.input = this.querySelector('input[type="search"]');
      this.results = this.querySelector('[data-results]');
      if (this.dataset.enabled !== 'true' || !this.input || !theme.routes.predictiveSearch) return;
      var self = this;
      this.input.addEventListener('input', function () {
        clearTimeout(self._t);
        self._t = setTimeout(function () { self.search(self.input.value.trim()); }, 250);
      });
    }
    search(term) {
      var self = this;
      if (!term) { this.results.innerHTML = ''; return; }
      if (this._controller) this._controller.abort();
      this._controller = new AbortController();
      var url = theme.routes.predictiveSearch + '?q=' + encodeURIComponent(term) +
        '&resources[type]=product,page,article&resources[limit]=6&resources[options][prefix]=last&section_id=predictive-search';
      fetch(url, { signal: this._controller.signal })
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var found = doc.querySelector('#predictive-search-results');
          self.results.innerHTML = found ? found.outerHTML : '';
        })
        .catch(function () {});
    }
  }
  customElements.define('predictive-search', PredictiveSearch);

  /* Quantity input */
  class QuantityInput extends HTMLElement {
    connectedCallback() {
      var input = this.querySelector('input');
      this.addEventListener('click', function (e) {
        var btn = e.target.closest('button');
        if (!btn) return;
        var min = parseInt(input.min, 10) || 0;
        var v = parseInt(input.value, 10) || 0;
        v = btn.name === 'plus' ? v + 1 : Math.max(min, v - 1);
        if (String(v) === input.value) return;
        input.value = v;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    }
  }
  customElements.define('quantity-input', QuantityInput);

  /* Cart */
  function updateCartCount(count) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      if (el.tagName === 'CART-ITEMS') return;
      el.textContent = count;
      el.hidden = count === 0;
    });
  }

  function renderCartSections(sections) {
    if (!sections) return;
    document.querySelectorAll('cart-items').forEach(function (el) {
      var html = sections[el.dataset.section];
      if (!html) return;
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var fresh = doc.querySelector('#' + el.id);
      if (!fresh) return;
      el.innerHTML = fresh.innerHTML;
      el.dataset.cartCount = fresh.dataset.cartCount;
      updateCartCount(parseInt(fresh.dataset.cartCount, 10) || 0);
    });
  }

  function cartSectionIds() {
    return Array.prototype.map.call(document.querySelectorAll('cart-items'), function (el) { return el.dataset.section; }).join(',');
  }

  class CartItems extends HTMLElement {
    connectedCallback() {
      var self = this;
      this.addEventListener('change', function (e) {
        if (e.target.matches('.quantity__input')) {
          self.update(e.target.dataset.line, Math.max(0, parseInt(e.target.value, 10) || 0));
        } else if (e.target.matches('[data-cart-note]')) {
          fetch(theme.routes.cart + '/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ note: e.target.value })
          });
        }
      });
      this.addEventListener('click', function (e) {
        var rm = e.target.closest('[data-remove-line]');
        if (rm) self.update(rm.dataset.removeLine, 0);
      });
    }
    update(line, quantity) {
      var self = this;
      this.classList.add('is-updating');
      fetch(theme.routes.cartChange + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ line: parseInt(line, 10), quantity: quantity, sections: cartSectionIds(), sections_url: window.location.pathname })
      })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          if (cart.status) { announce(cart.description || theme.strings.error); return; }
          renderCartSections(cart.sections);
        })
        .catch(function () { announce(theme.strings.error); })
        .finally(function () { self.classList.remove('is-updating'); });
    }
  }
  customElements.define('cart-items', CartItems);

  function openCartDrawer(opener) {
    var drawer = document.getElementById('cart-drawer');
    if (drawer) openDialog(drawer, opener);
    return !!drawer;
  }

  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-open-cart]');
    if (!opener) return;
    if (openCartDrawer(opener)) e.preventDefault();
  });

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form.matches || !form.matches('form.product-form')) return;
    if (theme.cartType !== 'drawer' || !document.getElementById('cart-drawer')) return;
    e.preventDefault();

    var buttons = document.querySelectorAll('[form="' + form.id + '"][type="submit"], #' + CSS.escape(form.id) + ' [type="submit"][name="add"]');
    var errorEl = form.querySelector('[data-form-error]');
    buttons.forEach(function (b) { b.classList.add('is-loading'); b.setAttribute('aria-busy', 'true'); });
    if (errorEl) errorEl.hidden = true;

    var data = new FormData(form);
    var qty = document.querySelector('input[name="quantity"][form="' + form.id + '"]');
    if (qty) data.set('quantity', qty.value);
    data.append('sections', cartSectionIds());
    data.append('sections_url', window.location.pathname);

    fetch(theme.routes.cartAdd + '.js', { method: 'POST', headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: data })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        if (res.status) {
          if (errorEl) { errorEl.textContent = res.description || res.message || theme.strings.error; errorEl.hidden = false; }
          return;
        }
        renderCartSections(res.sections);
        announce(theme.strings.added);
        openCartDrawer(e.submitter || buttons[0]);
      })
      .catch(function () {
        if (errorEl) { errorEl.textContent = theme.strings.error; errorEl.hidden = false; }
      })
      .finally(function () {
        buttons.forEach(function (b) { b.classList.remove('is-loading'); b.removeAttribute('aria-busy'); });
      });
  });

  /* Product: variant selection */
  class ProductInfo extends HTMLElement {
    connectedCallback() {
      var json = this.querySelector('[data-variants]');
      if (!json) return;
      this.variants = JSON.parse(json.textContent);
      this.form = document.getElementById(this.dataset.formId);
      var self = this;
      this.addEventListener('change', function (e) {
        if (e.target.matches('.variant-picker__input')) self.onChange();
      });
      this.markAvailability();
      this.setupStickyBar();
    }
    selectedOptions() {
      var opts = [];
      this.querySelectorAll('.variant-picker__option').forEach(function (fs) {
        var checked = fs.querySelector('.variant-picker__input:checked');
        opts.push(checked ? checked.value : null);
      });
      return opts;
    }
    onChange() {
      var opts = this.selectedOptions();
      var variant = this.variants.find(function (v) {
        return v.options.every(function (o, i) { return o === opts[i]; });
      });
      this.querySelectorAll('.variant-picker__option').forEach(function (fs, i) {
        var label = fs.querySelector('[data-selected-value]');
        if (label) label.textContent = opts[i] || '';
      });
      this.markAvailability();
      this.updateButtons(variant);
      if (!variant) return;
      var input = this.form && this.form.querySelector('[data-variant-input]');
      if (input) input.value = variant.id;
      this.updatePrice(variant);
      if (variant.featured_media) this.showMedia(variant.featured_media.id);
      if (this.dataset.updateUrl === 'true') {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url.toString());
      }
    }
    markAvailability() {
      var opts = this.selectedOptions();
      var variants = this.variants;
      this.querySelectorAll('.variant-picker__option').forEach(function (fs, index) {
        fs.querySelectorAll('.variant-picker__input').forEach(function (input) {
          var ok = variants.some(function (v) {
            if (!v.available || v.options[index] !== input.value) return false;
            return v.options.every(function (o, i) { return i === index || opts[i] == null || o === opts[i]; });
          });
          var pill = input.nextElementSibling;
          if (pill) pill.classList.toggle('is-unavailable', !ok);
        });
      });
    }
    updateButtons(variant) {
      var label;
      var mainBtn = this.querySelector('[data-add-button]');
      var preorder = mainBtn && mainBtn.dataset.preorder === 'true';
      if (!variant) label = theme.strings.unavailable;
      else if (!variant.available) label = theme.strings.soldOut;
      else label = preorder ? theme.strings.preorder : theme.strings.addToCart;
      var disabled = !variant || !variant.available;
      this.querySelectorAll('[data-add-button], [data-sticky-add]').forEach(function (btn) {
        btn.disabled = disabled;
        var span = btn.querySelector('[data-add-label]');
        if (span) span.textContent = label;
      });
    }
    updatePrice(variant) {
      var html = '<span class="price__current">' + formatMoney(variant.price) + '</span>';
      if (variant.compare_at_price && variant.compare_at_price > variant.price) {
        html += '<s class="price__compare">' + formatMoney(variant.compare_at_price) + '</s>';
      }
      this.querySelectorAll('[data-price]').forEach(function (el) {
        el.innerHTML = html;
        el.classList.toggle('price--sale', variant.compare_at_price > variant.price);
      });
    }
    showMedia(mediaId) {
      var item = this.querySelector('[data-media-id="' + mediaId + '"]');
      if (!item) return;
      var track = item.parentElement;
      if (track.scrollWidth > track.clientWidth) {
        track.scrollTo({ left: item.offsetLeft - track.offsetLeft, behavior: 'smooth' });
      }
    }
    setupStickyBar() {
      var bar = this.querySelector('[data-sticky-bar]');
      var main = this.querySelector('[data-main-buy]');
      if (!bar || !main || !('IntersectionObserver' in window)) return;
      var io = new IntersectionObserver(function (entries) {
        var e = entries[0];
        var below = e.boundingClientRect.top < 0;
        var show = !e.isIntersecting && below;
        bar.classList.toggle('is-visible', show);
        bar.setAttribute('aria-hidden', show ? 'false' : 'true');
        bar.querySelectorAll('button').forEach(function (b) { b.tabIndex = show ? 0 : -1; });
      });
      io.observe(main);
    }
  }
  customElements.define('product-info', ProductInfo);

  /* Media gallery */
  class MediaGallery extends HTMLElement {
    connectedCallback() {
      var track = this.querySelector('[data-track]');
      var counter = this.querySelector('[data-current]');
      var viewer = document.getElementById(this.dataset.viewer);
      if (track && counter) {
        track.addEventListener('scroll', function () {
          var i = Math.round(track.scrollLeft / Math.max(1, track.clientWidth));
          counter.textContent = i + 1;
        }, { passive: true });
      }
      this.addEventListener('click', function (e) {
        var zoom = e.target.closest('[data-zoom]');
        if (!zoom || !viewer) return;
        openDialog(viewer, zoom);
        var target = viewer.querySelector('[data-viewer-index="' + zoom.dataset.zoom + '"]');
        var scroller = viewer.querySelector('.viewer__track');
        if (target && scroller) setTimeout(function () { scroller.scrollTop = target.offsetTop; }, 20);
      });
    }
  }
  customElements.define('media-gallery', MediaGallery);

  /* Product recommendations */
  class ProductRecommendations extends HTMLElement {
    connectedCallback() {
      var self = this;
      if (!this.dataset.url || this.querySelector('.product-grid')) return;
      var load = function () {
        fetch(self.dataset.url)
          .then(function (r) { return r.text(); })
          .then(function (html) {
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var fresh = doc.querySelector('product-recommendations');
            if (fresh && fresh.innerHTML.trim()) self.innerHTML = fresh.innerHTML;
            else self.hidden = true;
          })
          .catch(function () {});
      };
      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (entries) {
          if (entries[0].isIntersecting) { io.disconnect(); load(); }
        }, { rootMargin: '0px 0px 400px 0px' });
        io.observe(this);
      } else load();
    }
  }
  customElements.define('product-recommendations', ProductRecommendations);

  /* Verse translation switch (remembered across the site) */
  class VerseSwitch extends HTMLElement {
    connectedCallback() {
      var self = this;
      var saved = null;
      try { saved = localStorage.getItem('evr-translation'); } catch (e) {}
      var available = (this.dataset.available || '').split(',').filter(Boolean);
      if (saved && available.indexOf(saved) !== -1) this.set(saved);
      this.addEventListener('click', function (e) {
        var btn = e.target.closest('[data-set-translation]');
        if (!btn) return;
        var code = btn.dataset.setTranslation;
        try { localStorage.setItem('evr-translation', code); } catch (err) {}
        document.querySelectorAll('verse-switch').forEach(function (v) { v.set(code); });
      });
    }
    set(code) {
      var has = this.querySelector('[data-translation="' + code + '"]');
      if (!has) return;
      this.querySelectorAll('[data-translation]').forEach(function (p) { p.hidden = p.dataset.translation !== code; });
      this.querySelectorAll('[data-set-translation]').forEach(function (b) { b.setAttribute('aria-pressed', b.dataset.setTranslation === code ? 'true' : 'false'); });
      var label = this.querySelector('[data-translation-label]');
      if (label) label.textContent = code.toUpperCase();
    }
  }
  customElements.define('verse-switch', VerseSwitch);

  /* Copy link */
  class CopyLink extends HTMLElement {
    connectedCallback() {
      var self = this;
      var btn = this.querySelector('button');
      if (!btn) return;
      btn.addEventListener('click', function () {
        var url = self.dataset.url || window.location.href;
        if (navigator.share && window.matchMedia('(pointer: coarse)').matches) {
          navigator.share({ url: url, title: document.title }).catch(function () {});
          return;
        }
        if (navigator.clipboard) {
          navigator.clipboard.writeText(url).then(function () {
            var original = btn.textContent;
            btn.textContent = theme.strings.copied;
            announce(theme.strings.copied);
            setTimeout(function () { btn.textContent = original; }, 2000);
          });
        }
      });
    }
  }
  customElements.define('copy-link', CopyLink);

  /* Facet form placeholder (filters are submitted by the form itself) */
  class FacetForm extends HTMLElement {}
  customElements.define('facet-form', FacetForm);

  document.addEventListener('DOMContentLoaded', syncModeButtons);
  document.addEventListener('shopify:section:load', syncModeButtons);
})();
